import './index.scss';

function NotFound() {
  return (
    <main className="not-found">
      <h1>404</h1>
      <p>Page not found.</p>
    </main>
  );
}

export default NotFound;
